import { useEffect, useState } from 'react';

interface StatisticRowProps {
  value: string | number
  title: string;
  limit?: number;
  className?: string;
}

function StatisticRow( { value, title, limit, className = '' }: StatisticRowProps ) {
  const [ colors, setColors ] = useState( 'bg-app-color-very-light text-app-color' );
  const [ shownValue, setShownValue ] = useState<string>( value as string );

  useEffect( () => {
    const numberValue = parseFloat( value as string );
    if ( numberValue && limit != null ) {
      setColors( `${ numberValue > limit ? 'bg-green-100' : numberValue < limit ? 'bg-red-100' : 'bg-gray-100'}` );
    }
    else {
      setShownValue( value as string );
    }
  }, [ value, limit ] );

  return (
    <div className={ `flex-center flex-col h-full w-full  ${ colors } ${ className }` }>
      <span className="text-gray-500 text-sm">{title}</span>
      <span className="text-3xl font-semibold">
        { `${shownValue}` }
      </span>
    </div>
  );
}

export default StatisticRow;
